import type React from "react"
import { useNavigate } from "react-router-dom"

import styled, { css } from "styled-components"

interface LinkTextWrapperProps {
  color?: string
  fontWeight?: number
  padding?: string
}
const LinkTextWrapper = styled.div<LinkTextWrapperProps>`
  color: ${(props) => props.theme.colors.primary};
  text-align: center;
  padding: 8px;

  ${(props) =>
    props &&
    css`
      ${props.color ? `color: ${props.color};` : ""}
      ${props.padding && `padding: ${props.padding};`}
    `}

  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

interface LinkTextProps extends LinkTextWrapperProps {
  to: string
  text: string
}

export const LinkText: React.FC<LinkTextProps> = ({ to, text, ...props }) => {
  const navigate = useNavigate()
  return (
    <LinkTextWrapper {...props} role="link" onClick={() => navigate(to)}>
      {text}
    </LinkTextWrapper>
  )
}
